import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { coronaConfig } from "./data";

export default function CoronaPage() {
  return <CityPageTemplate config={coronaConfig} />;
}